"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSpecialtyDto = instanceOfSpecialtyDto;
exports.SpecialtyDtoFromJSON = SpecialtyDtoFromJSON;
exports.SpecialtyDtoFromJSONTyped = SpecialtyDtoFromJSONTyped;
exports.SpecialtyDtoToJSON = SpecialtyDtoToJSON;
exports.SpecialtyDtoToJSONTyped = SpecialtyDtoToJSONTyped;
/**
 * Check if a given object implements the SpecialtyDto interface.
 */
function instanceOfSpecialtyDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('assessmentIds' in value) || value['assessmentIds'] === undefined)
        return false;
    return true;
}
function SpecialtyDtoFromJSON(json) {
    return SpecialtyDtoFromJSONTyped(json, false);
}
function SpecialtyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'active': json['active'],
        'assessmentIds': json['assessmentIds'],
    };
}
function SpecialtyDtoToJSON(json) {
    return SpecialtyDtoToJSONTyped(json, false);
}
function SpecialtyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'active': value['active'],
        'assessmentIds': value['assessmentIds'],
    };
}
//# sourceMappingURL=SpecialtyDto.js.map